// src/modules/app-views/_apps/appmulti/orders/pages/Document/actions/menuButton.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { CheckCircleOutlined, MailOutlined, MoreOutlined, StopOutlined } from '@ant-design/icons';

import { dropdownDivider } from 'layouts/Pages/PageHeader/dropdownMenus';
import appService from 'services/appService';
import axiosService from 'services/axiosService';
import translateX from 'utils/translateX';
import { API } from 'constants/Api';

// *******************************************************************************
// HELPERS
// *******************************************************************************
const statusOf = data => data?.__statusView || data?.status;

// *******************************************************************************
// CUSTOM ITEMS
// *******************************************************************************
const finishOrderItem = {
  key: 'finish_order',
  label: 'finish_order',
  icon: <CheckCircleOutlined />,
  hidden: ({ currentPage }) =>
    statusOf(currentPage?.data) !== 'waiting_for_voucher',
  onClick: async ({ page, refreshDocument, apiGlobal }) => {
    const data = page?.data;
    if (!data?._id) return;
    await axiosService.put({
      url: API.APPMULTI_ORDER.DETAIL.replace(':_id', data._id),
      data: { status: 'done' },
    });
    if (typeof refreshDocument === 'function') refreshDocument(data._id);
    else apiGlobal?.refresh?.({ _id: data._id, showLoading: false });
  },
};

const resendEmailItem = {
  key: 'resend_email',
  label: 'resend_email',
  icon: <MailOutlined />,
  hidden: ({ currentPage }) => !currentPage?.data?._id,
  onClick: async ({ page }) => {
    const data = page?.data;
    if (!data?._id) return;
    const s = statusOf(data);
    const action = s === 'done'
      ? 'done'
      : ['cancelled', 'cancelled_by_customer'].includes(s)
        ? 'cancelled'
        : 'created';
    await axiosService.post({
      url: API.APPMULTI_ORDER.SEND_EMAIL,
      data: { action, _id: data._id },
    });
    appService.message({ flag: 's', text: 'email_sent' });
  },
};

const cancelOrderItem = {
  key: 'cancel_order',
  label: 'cancel_order',
  icon: <StopOutlined />,
  danger: true,
  hidden: ({ currentPage }) =>
    ['done', 'cancelled', 'cancelled_by_customer'].includes(
      statusOf(currentPage?.data),
    ),
  onClick: ({ page, refreshDocument, apiGlobal }) => {
    const data = page?.data;
    if (!data?._id) return;
    appService.modal({
      flag: 'confirm',
      title: translateX('cancel_order'),
      content: translateX('cancel_order_confirm'),
      onOk: async () => {
        await axiosService.put({
          url: API.APPMULTI_ORDER.CANCEL_BY_ID.replace(':_id', data._id),
          data: {},
        });
        if (typeof refreshDocument === 'function') refreshDocument(data._id);
        else apiGlobal?.refresh?.({ _id: data._id, showLoading: false });
      },
    });
  },
};

// *******************************************************************************
// MENU BUTTON
// *******************************************************************************
const ordersDocumentMenuButton = () => ({
  action: 'dropdownMenu',
  icon: <MoreOutlined />,
  tooltip: 'more_options',
  dropdownItems: [
    finishOrderItem,
    resendEmailItem,
    dropdownDivider,
    cancelOrderItem,
  ],
});

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default ordersDocumentMenuButton;
